// import moment from 'moment';
// import { GridColDef } from "@mui/x-data-grid";

// // Types for better type safety
// interface TableGenerationResult {
//     html: string;
//     totalFees: number;
// }

// interface PrintPDFConfig {
//     client: string;
//     selectedYear: string;
//     selectedMonth: number;
//     groupedData: Record<string, any[]>;
//     columns: GridColDef[];
// }

// // Constants
// const DATE_FORMAT = {
//     MONTH: "MMMM",
//     SHORT_DATE: "MM/DD/YYYY"
// };

// const LOGO_DIMENSIONS = {
//     width: 70,
//     height: 60
// };

// // Helper Functions
// const getLogoSvg = (): string => {
//     const svgContent = `
//         <svg xmlns="http://www.w3.org/2000/svg" width="${LOGO_DIMENSIONS.width}px" height="${LOGO_DIMENSIONS.height}px">
//             <rect width="${LOGO_DIMENSIONS.width}" height="${LOGO_DIMENSIONS.height}" fill="#fff"/>
//             <path d="M0 0 C3.30456114 1.65228057 4.83272811 2.58545539 7.29980469 5.07275391 C8.23031647 6.00349228 8.23031647 6.00349228 9.17962646 6.95303345 C10.16578949 7.95468033 10.16578949 7.95468033 11.171875 8.9765625 C11.8542926 9.66181 12.53671021 10.3470575 13.23980713 11.05307007 C15.41461598 13.23905845 17.58236072 15.43190429 19.75 17.625 C21.2247999 19.10983255 22.70005506 20.59421306 24.17578125 22.078125 C27.78915448 25.7135291 31.39620853 29.35509824 35 33 C37.95170386 31.67195147 40.00588046 30.23365273 42.26806641 27.92724609 C43.18889511 26.99650772 43.18889511 26.99650772 44.12832642 26.04696655 C44.77949432 25.37920197 45.43066223 24.71143738 46.1015625 24.0234375 C46.77923676 23.33819 47.45691101 22.6529425 48.15512085 21.94692993 C50.31661346 19.76102388 52.4715406 17.56881874 54.625 15.375 C57.46569408 12.48132672 60.31278034 9.59417394 63.1640625 6.7109375 C63.81927887 6.03912445 64.47449524 5.3673114 65.14956665 4.67514038 C66.06093887 3.75385849 66.06093887 3.75385849 66.99072266 2.81396484 C67.7920311 1.99694595 67.7920311 1.99694595 68.60952759 1.16342163 C70 0 70 0 72 0 C74.4707907 8.45882463 75.71607551 17.74150147 72 26 C67.41994256 33.03442772 61.32080778 38.88320012 55.3125 44.6875 C54.52063293 45.4589032 53.72876587 46.2303064 52.91290283 47.02508545 C50.61093443 49.23965452 48.28067805 51.41610548 45.92578125 53.57421875 C45.20770798 54.24064896 44.4896347 54.90707916 43.74980164 55.59370422 C43.06964493 56.1914415 42.38948822 56.78917877 41.6887207 57.4050293 C41.09581741 57.93283493 40.50291412 58.46064056 39.89204407 59.00444031 C38 60 38 60 35.38525391 59.74960327 C32.64558573 58.88861978 31.43107043 57.89578335 29.44921875 55.83984375 C28.52592773 54.8972168 28.52592773 54.8972168 27.58398438 53.93554688 C26.95814453 53.27619141 26.33230469 52.61683594 25.6875 51.9375 C25.04232422 51.27427734 24.39714844 50.61105469 23.73242188 49.92773438 C22.14552982 48.29382329 20.56873672 46.65131853 19 45 C16.06936481 46.31723754 14.05284056 47.72148646 11.8359375 50.0390625 C11.27132813 50.61914062 10.70671875 51.19921875 10.125 51.796875 C9.5475 52.40015625 8.97 53.0034375 8.375 53.625 C7.22082483 54.83001989 6.06218537 56.03078487 4.8984375 57.2265625 C4.38974121 57.75846191 3.88104492 58.29036133 3.35693359 58.83837891 C2 60 2 60 0 60 C0 40.2 0 20.4 0 0 Z " fill="#2099D2" transform="translate(0,0)"/>
//             <path d="M0 0 C0.66 0 1.32 0 2 0 C2 7.92 2 15.84 2 24 C-5.92 24 -13.84 24 -22 24 C-15.26052471 16.13727883 -15.26052471 16.13727883 -12.16796875 13.10546875 C-11.51505859 12.46029297 -10.86214844 11.81511719 -10.18945312 11.15039062 C-9.19848633 10.17875977 -9.19848633 10.17875977 -8.1875 9.1875 C-6.84537138 7.87081457 -5.50541323 6.5519119 -4.16796875 5.23046875 C-3.58297607 4.65707764 -2.9979834 4.08368652 -2.39526367 3.49291992 C-0.89784025 2.03233739 -0.89784025 2.03233739 0 0 Z " fill="#162D3C" transform="translate(70,36)"/>
//         </svg>
//     `;
//     return `data:image/svg+xml;base64,${btoa(svgContent)}`;
// };

// const getStyles = (): string => `
//     @page {
//         margin: 20px;
//         size: auto;
//     }
//     body {
//         font-family: Arial, sans-serif;
//         margin: 0;
//         padding: 20px;
//     }
//     .header {
//         text-align: left;
//         margin-bottom: 20px;
//     }
//     .header-flex {
//         display: flex;
//         align-items: center;
//     }
//     .header-title {
//         font-size: 30px;
//         font-family: 'Calibri Light', Arial, sans-serif;
//         font-weight: 1000;
//         margin: 0;
//     }
//     .header-subtitle {
//         font-weight: lighter;
//         margin: 0 0 0 70px;
//         font-size: 20px;
//     }
//     .date-info {
//         margin: 10px 0 0 70px;
//     }
//     .date-info p {
//         margin: 0;
//         margin-top: 10px;
//     }
//     table {
//         width: 100%;
//         margin-bottom: 20px;
//         border-collapse: collapse;
//         table-layout: fixed;
//     }
//     th {
//         background: grey;
//         color: white;
//         text-align: left;
//         padding: 12px;
//     }
//     tr:nth-child(even) {
//         background: #f2f2f2;
//     }
//     td {
//         padding: 8px;
//         word-wrap: break-word;
//     }
//     .fee-dues {
//         text-align: right;
//     }
//     .total-row td {
//         text-align: right;
//         color: red;
//         font-weight: bold;
//         font-size: 20px;
//     }
//     @media print {
//         th {
//             background: grey !important;
//             -webkit-print-color-adjust: exact;
//         }
//         tr {
//             page-break-inside: avoid;
//         }
//         thead {
//             display: table-header-group;
//         }
//         tfoot {
//             display: table-footer-group;
//         }
//     }
// `;

// const formatValue = (value: any, field: string): string => {
//     if (value === null || value === undefined) return "";
    
//     switch(field) {
//         case "isPaymentRequired":
//         case "isReportRequired":
//             return value ? "✓" : "";
//         case "period":
//             return value ? moment(value).format(DATE_FORMAT.MONTH) : "";
//         case "dateFinal":
//             return value ? moment(value).format(DATE_FORMAT.SHORT_DATE) : "";
//         case "feeDue":
//             return value ? value.toString() : "0.00";
//         default:
//             return value.toString();
//     }
// };

// const generateTableHTML = (
//     groupedData: Record<string, any[]>, 
//     columns: GridColDef[]
// ): TableGenerationResult => {
//     let tableHTML = '';
//     let grandTotalFeeDue = 0;
    
//     Object.entries(groupedData).forEach(([, rows]) => {
//         tableHTML += `
//             <table>
//                 <thead>
//                     <tr>${columns
//                         .filter(col => !col.hide)
//                         .map(col => `<th>${col.headerName}</th>`)
//                         .join('')}
//                     </tr>
//                 </thead>
//                 <tbody>
//                     ${rows.map(row => `
//                         <tr>${columns
//                             .filter(col => !col.hide)
//                             .map(col => {
//                                 const value = row[col.field];
//                                 const formattedValue = formatValue(value, col.field);
                                
//                                 if (col.field === 'feeDue') {
//                                     grandTotalFeeDue += parseFloat(value) || 0;
//                                     return `<td class="fee-dues">$${formattedValue}</td>`;
//                                 }
//                                 return `<td>${formattedValue}</td>`;
//                             })
//                             .join('')}
//                         </tr>
//                     `).join('')}
//                 </tbody>
//             </table>
//         `;
//     });

//     return { html: tableHTML, totalFees: grandTotalFeeDue };
// };

// export const printPDFReport = (
//         client: string,
//         selectedYear: string,
//         selectedMonth: number,
//         groupedData: Record<string, any[]>,
//         Columns: GridColDef[]
//     ): void => {
//     const printWindow = window.open("", "_blank");
//     if (!printWindow) {
//         console.error("Failed to open print window");
//         return;
//     }

//     const startDate = moment(new Date(parseInt(selectedYear, 10), selectedMonth - 1, 1))
//         .format(DATE_FORMAT.SHORT_DATE);
//     const endDate = moment(new Date(parseInt(selectedYear, 10), selectedMonth, 0))
//         .format(DATE_FORMAT.SHORT_DATE);
    
//     const { html: tableHTML, totalFees } = generateTableHTML(groupedData, Columns);

//     const content = `
//         <!DOCTYPE html>
//         <html lang="en">
//             <head>
//                 <meta charset="UTF-8">
//                 <title>Filed Transactions Report</title>
//                 <style>${getStyles()}</style>
//             </head>
//             <body>
//                 <div class="header">
//                     <div class="header-flex">
//                         <img src="${getLogoSvg()}" alt="Logo" style="height:${LOGO_DIMENSIONS.height}px;width:${LOGO_DIMENSIONS.width}px;margin-right:5px">
//                         <h1 class="header-title">Filed Transactions</h1>
//                     </div>
//                     <h4 class="header-subtitle">${client}</h4>
//                     <div class="date-info">
//                         <p>Start Date: ${startDate}</p>
//                         <p>End Date: ${endDate}</p>
//                     </div>
//                 </div>
//                 ${tableHTML}
//                 <table>
//                     <tfoot>
//                         <tr class="total-row">
//                             <td colspan="${Columns.length - 1}">Fees Due</td>
//                             <td class="fee-dues" style="width: 100px;">
//                                 $${totalFees.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
//                             </td>
//                         </tr>
//                     </tfoot>
//                 </table>
//             </body>
//         </html>
//     `;

//     printWindow.document.write(content);
//     printWindow.document.close();
    
//     // Wait for resources to load before printing
//     printWindow.addEventListener('load', () => {
//         printWindow.print();
//     });
// };


import moment from 'moment';
import { GridColDef } from "@mui/x-data-grid";

// Types and interfaces for critical functionality
interface PrintConfig {
    client: string;
    selectedYear: string;
    selectedMonth: number;
    groupedData: Record<string, any[]>;
    columns: GridColDef[];
}

// Use MISC logo for consistent branding
const LOGO = "/assets/brand/MISC_Brandmark_Secondary(1).png";

// Professional CSS styling matching StateReportBillingList format
const STYLES = `
    * { box-sizing: border-box; }
    body { 
      font: 11px Arial, sans-serif; 
      margin: 0; 
      padding: 15px; 
      line-height: 1.2;
    }
    .header { 
      display: flex; 
      align-items: center; 
      margin-bottom: 20px; 
      border-bottom: 2px solid #2099D2; 
      padding-bottom: 10px;
    }
    .header img { 
      height: 50px; 
      width: 58px; 
      margin-right: 15px; 
    }
    .header h1 { 
      margin: 0; 
      font-size: 18px; 
      color: #2099D2; 
      font-weight: bold;
    }
    .meta { 
      text-align: right; 
      margin-bottom: 15px; 
      font-size: 10px; 
      color: #666;
    }
    .client-section { 
      margin-bottom: 20px; 
    }
    .client-header { 
      background: #f0f0f0 !important; 
      padding: 8px; 
      font-weight: bold; 
      border-left: 4px solid #2099D2;
      font-size: 12px;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
    .date-range { 
      font-size: 10px; 
      color: #666; 
      margin: 5px 0;
    }
    table { 
      width: 100%; 
      border-collapse: collapse; 
      margin-bottom: 15px; 
      font-size: 10px;
      table-layout: fixed;
    }
    th { 
      background: #2099D2 !important; 
      color: white !important; 
      padding: 6px 4px; 
      text-align: center; 
      font-weight: bold;
      border: 1px solid #ddd;
      font-size: 9px;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
      width: auto;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    td { 
      padding: 4px; 
      text-align: center; 
      border: 1px solid #ddd; 
      word-wrap: break-word;
      font-size: 9px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    tr:nth-child(even) { 
      background: #f9f9f9 !important; 
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
    .total-row { 
      font-weight: bold; 
      background: #e6f3ff !important; 
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
    .currency { 
      text-align: right; 
    }
    .fee {
      text-align: right;
    }
    .total td{
      color: #000; 
      font-weight: bold; 
      font-size: 12px; 
      text-align: right;
    }
    @media print {
      * { 
        -webkit-print-color-adjust: exact !important; 
        color-adjust: exact !important; 
      }
      body { font-size: 9px; }
      .header h1 { font-size: 16px; }
      table { 
        font-size: 8px; 
        table-layout: fixed;
      }
      th { 
        background: #2099D2 !important; 
        color: white !important; 
        width: auto;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      td {
        overflow: hidden;
        text-overflow: ellipsis;
      }
      tr:nth-child(even) { 
        background: #f9f9f9 !important; 
      }
      .total-row {
        background: #e6f3ff !important;
      }
      .client-header {
        background: #f0f0f0 !important;
      }
    }
`;

// Combined format function
const fmt = (v: any, f: string): string => {
    if (v == null) return "";
    switch(f) {
        case "isPaymentRequired":
        case "isReportRequired": return v ? "✓" : "";
        case "period": return v ? moment(v).format("MMMM") : "";
        case "dateFinal": return v ? moment(v).format("MM/DD/YYYY") : "";
        case "feeDue": return v ? v.toString() : "0.00";
        default: return v.toString();
    }
};

// Main export function
export const printPDFReport = (
        client: string,
        selectedYear: string,
        selectedMonth: number,
        groupedData: Record<string, any[]>,
        Columns: GridColDef[]
    ): void => {
    const win = window.open("", "_blank");
    if (!win) return;

    let tableHTML = '', total = 0;
    
    // Generate tables for each group
    Object.values(groupedData).forEach(rows => {
        tableHTML += `<table>
            <thead><tr>${Columns.filter(c => !c.hide)
                .map(c => `<th>${c.headerName}</th>`).join('')}</tr></thead>
            <tbody>${rows.map(row => `<tr>${Columns.filter(c => !c.hide)
                .map(c => {
                    const val = row[c.field];
                    if (c.field === 'feeDue') {
                        total += parseFloat(val) || 0;
                        return `<td class="fee">$${fmt(val, c.field)}</td>`;
                    }
                    return `<td>${fmt(val, c.field)}</td>`;
                }).join('')}</tr>`).join('')}</tbody>
        </table>`;
    });

    // Create document content with new professional format
    const content = `<!DOCTYPE html>
        <html lang="en">
            <head>
                <meta charset="UTF-8">
                <style>${STYLES}</style>
            </head>
            <body>
                <div class="header">
                    <img src="${LOGO}" alt="MISC Logo">
                    <h1>Filed Transactions</h1>
                </div>
                <div class="meta">
                    Generated: ${moment().format("dddd, MMMM DD, YYYY")} at ${moment().format("hh:mm A")}
                </div>
                <div class="client-section">
                    <div class="client-header">${client}</div>
                    <div class="date-range">
                        Start Date: ${moment(new Date(+selectedYear, selectedMonth - 1, 1)).format("MM/DD/YYYY")} | 
                        End Date: ${moment(new Date(+selectedYear, selectedMonth, 0)).format("MM/DD/YYYY")}
                    </div>
                </div>
                ${tableHTML}
                <table>
                    <tfoot>
                        <tr class="total-row">
                            <td colspan="${Columns.filter(c => !c.hide).length - 1}"><strong>Total Fees Due</strong></td>
                            <td class="fee">
                                <strong>$${total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</strong>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </body>
        </html>`;

    win.document.write(content);
    win.document.close();
    win.addEventListener('load', () => win.print());
};